import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/track", label: "Track" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 bg-zinc-950/95 backdrop-blur border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-8 h-16">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <img
            src="https://customer-assets-m6fa6gv7.emergentagent.net/job_kpmx-service-portal/artifacts/kb72pc4y_1000238527.png"
            alt="KPMX"
            className="h-12 md:h-14 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm uppercase tracking-widest transition-colors ${
                  isActive ? "text-orange-500" : "text-zinc-300 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user && user !== false ? (
            <>
              <Link
                to="/admin"
                data-testid="nav-admin-dashboard"
                className="text-xs uppercase tracking-widest text-zinc-300 hover:text-white"
              >
                Dashboard
              </Link>
              <button
                data-testid="nav-logout-btn"
                onClick={async () => { await logout(); navigate("/"); }}
                className="text-xs uppercase tracking-widest text-zinc-500 hover:text-orange-500"
              >
                Logout
              </button>
            </>
          ) : null}
          <Link
            to="/book"
            data-testid="nav-book-btn"
            className="btn-hard bg-orange-600 hover:bg-orange-500 text-white text-sm uppercase tracking-widest px-5 py-2.5 font-semibold"
          >
            Book Now
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-zinc-950 border-t border-white/10" data-testid="nav-mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base uppercase tracking-widest ${isActive ? "text-orange-500" : "text-zinc-200"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/book"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-book"
              className="bg-orange-600 text-white text-center py-3 uppercase tracking-widest font-semibold"
            >
              Book Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
